import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const TransactionListOutline = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M19.187 20.089c.716-4.408 1.702-14.34-.902-16.526-2.427-2.037-10.007-2.13-12.62 0-2.558 2.092-1.581 12.118-.902 16.526 0 .158.083.316.083.4.168.474.345.958.68 1.032.167.084.427-.084.51-.158.261-.316.512-.632.773-.958.344-.4 1.023-.4 1.45.084.345.4.596.716.94 1.116a.88.88 0 0 0 1.367.074c.26-.316.512-.716.856-1.032.344-.474 1.106-.474 1.45 0 .26.316.512.716.856 1.032.344.475 1.023.4 1.367-.074.26-.4.595-.716.94-1.116.427-.474 1.106-.558 1.45-.084.26.316.512.633.772.958.084.084.428 0 .512-.158.158-.316.335-.716.418-1.116Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <Path d="M15.904 15.333a66.87 66.87 0 0 1-7.96 0h7.96Z" fill="#AAABAD" />
    <Path
      d="M15.904 15.333a66.87 66.87 0 0 1-7.96 0"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path d="M7.953 12h7.96-7.96Z" fill="#AAABAD" />
    <Path
      d="M7.953 12h7.96"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path d="M7.953 8.29c1.348-.083 2.622-.083 3.98-.083h.874" fill="#AAABAD" />
    <Path
      d="M7.953 8.29c1.348-.083 2.622-.083 3.98-.083h.874"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M15.722 8.259a.297.297 0 0 1-.296.296.298.298 0 0 1-.297-.296c0-.163.134-.297.297-.297.162 0 .296.134.296.297Z"
      stroke="currentColor"
      strokeWidth={1.407}
    />
  </Icon>
);

export default TransactionListOutline;
